module.exports = __webpack_public_path__ + "71b60db7dec935e0eb865638c93a3ea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/ads/apple_sample_ad.jpg
// module id = 1607
// module chunks = 0